import { getDefaultHeadData } from '@/lib/utils'

export default {
  head () {
    return getDefaultHeadData({
      title: this.$t('meta.index.title'),
      description: this.$t('meta.index.description'),
      locale: this.$i18n.locale,
    })
  },
}
